export enum CreativePlaceholderId {
    NavigationBannerDesktop = 'navigation-banner-desktop',
    HeroStageDesktop = 'hero-stage-desktop',
    HeroStageMobile = 'hero-stage-mobile',
    HeroBanner = 'hero-banner',
}
